import React from "react";
import { useHistory } from "react-router-dom";
import InspectionSuccessNative from "./InspectionSuccess.native";

const InspectionSuccessContainer = () => {
  const history = useHistory();
  const isConnected = navigator.onLine;

  const goToPanel = () => history.push('/first-step');

  return (
    <div>
      <InspectionSuccessNative isConnected={isConnected} onClose={goToPanel} />
    </div>
  );
};

export default InspectionSuccessContainer;
